"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = makeForm;

var _react = _interopRequireWildcard(require("react"));

var _useForm = require("./useForm");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function makeForm() {
  var mainConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var Context = /*#__PURE__*/(0, _react.createContext)({
    attrs: mainConfig.initial
  }); // eslint-disable-next-line react/prop-types

  function FormProvider(_ref) {
    var config = _ref.config,
        children = _ref.children,
        attrs = _ref.attrs,
        onChange = _ref.onChange,
        onSet = _ref.onSet;

    if (attrs && !mainConfig.initial) {
      mainConfig.initial = attrs;
    }

    var helpers = (0, _useForm.useForm)(mainConfig, config);
    var formAttrs = helpers.attrs,
        setFormAttrs = helpers.setFormAttrs,
        _amendInitialConfig = helpers._amendInitialConfig,
        _action = helpers._action;
    (0, _react.useEffect)(function () {
      if (config) {
        _amendInitialConfig(config);
      }
    }, [config]);
    (0, _react.useEffect)(function () {
      if (_action !== null && _action !== void 0 && _action.isAttrUpdate && onChange && !_action._processed) {
        _action._processed = true;
        onChange(formAttrs);
      } else if (attrs && attrs !== formAttrs) {
        onSet(function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return setFormAttrs.apply(void 0, [attrs].concat(args));
        }, {
          attrs: formAttrs,
          nextAttrs: attrs
        });
      }
    }, [attrs, formAttrs, _action, onChange, onSet]);
    return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
      value: helpers
    }, children);
  }

  FormProvider.defaultProps = {
    onSet: function onSet(setAttrs) {
      return setAttrs();
    }
  };

  function useContextForm() {
    return (0, _react.useContext)(Context);
  }

  return [FormProvider, useContextForm];
}